import JwPagination from 'jw-react-pagination'
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
} from 'reactstrap'
import {
  toggleAllAssignableUsers,
  filterGroupUsers,
  toggleAssignableGroupUser,
} from 'store/Group/actions'

import {
  setHideSelectedUsersItems,
  setShowSelectedUsersItems,
} from 'store/Users/actions'

import Search from '../../../Search'
import SelectedItems from '../../../SelectedItems'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleLeft,
  faAngleRight,
} from '@fortawesome/free-solid-svg-icons'
import Loader from 'views/pages/Loader'

const UsersModal = (props) => {
  const dispatch = useDispatch()
  const groups = useSelector((state) => state.groups)
  const { items, users } = props
  const [pageOfItems, setPageOfItems] = useState([])
  const [filteredUsers, setFilteredUsers] = useState([]);

  useEffect(() => {
    const searchTerm = groups.filterGroupUsersValue.toLowerCase();
    const filtered = items.filter(user =>
      `${user.first_name} ${user.last_name}`.toLowerCase().includes(searchTerm)
    );
    setFilteredUsers(filtered);
  }, [groups.filterGroupUsersValue, items]);

  const onChangeUserPage = (pageOfItems) => {
    setPageOfItems(pageOfItems)
  }

  const handleSearch = (e) => {

    dispatch(filterGroupUsers(e.target.value));
  }

  const customLabels = {
    first: <FontAwesomeIcon icon={faAngleDoubleLeft} />,
    last: <FontAwesomeIcon icon={faAngleDoubleRight} />,
    previous: <FontAwesomeIcon icon={faAngleLeft} />,
    next: <FontAwesomeIcon icon={faAngleRight} />,
  }

  return (
    <Modal
      className='modal-dialog-centered'
      isOpen={props.isOpen}
      size='xl'
      toggle={() => props.setUsersModal(!props.isOpen)}
      scrollable
    >
      <ModalHeader
        className='border-bottom pb-2'
        toggle={() => props.setUsersModal(false)}
      >
        <span className='text-info'>Users</span>
      </ModalHeader>
      <ModalBody className='scrollbar' style={{ minHeight: '60vh' }}>
        {users.isLoading ? (
          <Loader />
        ) : (
          <>
            <Row className='justify-content-between align-items-center px-2'>
              <div>All Users:</div>

              <JwPagination
                pageSize={30}
                disableDefaultStyles={true}
                items={filteredUsers}
                onChangePage={onChangeUserPage}
                labels={customLabels}
              />
              <Search
                placeholder={'Search users'}
                value={groups.filterGroupUsersValue}
                onChange={handleSearch}
              />
            </Row>

            <div className='col'>
              <div className='col-3 mb-3 pl-0'>
                <SelectedItems
                  items={
                    filteredUsers // Use filteredUsers here
                      .filter((item) =>
                        groups.assignableTrainingUsers.includes(item.id)
                      )
                      .sort((a, b) => (a.first_name > b.first_name ? 1 : -1))
                  }
                  selectedItems={groups.assignableTrainingUsers}
                  showSelectedItems={users.showSelectedUsersItems}
                  hasDisabledProperty={false}
                  onChange={toggleAssignableGroupUser}
                  isUsersSelect={true}
                  setShowSelectedItems={() =>
                    dispatch(setShowSelectedUsersItems())
                  }
                  setHideSelectedItems={() =>
                    dispatch(setHideSelectedUsersItems())
                  }
                />
              </div>

              {filteredUsers.length && !groups.filterGroupUsersValue ? (
                <div className='custom-control custom-checkbox-info mt-4'>
                  <input
                    className='custom-control-input'
                    id='allUsers'
                    type='checkbox'
                    onChange={() => dispatch(toggleAllAssignableUsers())}
                    checked={
                      filteredUsers.length <= groups.assignableTrainingUsers.length
                    }
                  />
                  <label className='custom-control-label' htmlFor='allUsers'>
                    All
                  </label>
                </div>
              ) : null}
              {pageOfItems.map((item) => (
                <div
                  key={item.id}
                  className='custom-control custom-checkbox-info mb-1'
                >
                  <input
                    className='custom-control-input'
                    id={`checkbox${item.id}`}
                    type='checkbox'
                    checked={
                      groups.assignableTrainingUsers.indexOf(item.id) !== -1
                    }
                    onChange={() =>
                      dispatch(toggleAssignableGroupUser(item.id))
                    }
                  />
                  <label
                    className='custom-control-label'
                    htmlFor={`checkbox${item.id}`}
                  >
                    {`${item.first_name} ${item.last_name}`}
                  </label>
                </div>
              ))}
            </div>
          </>
        )}
      </ModalBody>
      <ModalFooter className='border-top py-2'>
        <Button
          className='ml-auto'
          color='link'
          data-dismiss='modal'
          type='button'
          onClick={() => props.setUsersModal(false)}
        >
          Close
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default UsersModal
